const getCellKey = (rowIndex, columnIndex, type) => {
  return `${rowIndex}:${columnIndex}-${type}`;
};
const getPinnedColumnsWidth = (itemData) => {
  const { pinnedColumns, columnStyles, theme } = itemData;
  if (!pinnedColumns)
    return theme.indexColumn.width;
  if (columnStyles[pinnedColumns.length]) {
    return columnStyles[pinnedColumns.length].left;
  }
  return pinnedColumns.reduce((memo, pinnedIndex, index) => {
    return memo + columnStyles[index].width;
  }, theme.indexColumn.width);
};
const getAverageColumnWidth = (itemData) => {
  const { columns, columnStyles } = itemData;
  const totalColumns = columns.length;
  if (!totalColumns)
    return 0;
  const totalWidth = columnStyles[totalColumns - 1].left + columnStyles[totalColumns - 1].width;
  return totalWidth / totalColumns;
};
const getHasVariableColumns = (itemData) => {
  const { columnStyles, theme } = itemData;
  for (let i = 0; i < columnStyles.length; i++) {
    if (columnStyles[i].width !== theme.column.width) {
      return true;
    }
  }
  return false;
};
export {
  getAverageColumnWidth,
  getCellKey,
  getHasVariableColumns,
  getPinnedColumnsWidth
};
